import { get } from 'lodash';
import { State } from '../types';

interface Props {
  identifier: string;
}

export const locationAutocompleteSuggestions = (state: State, ownProps: Props) =>
  get(state, `locationAutocomplete.${ownProps.identifier}.suggestions`, []);

export const locationAutocompleteInputDisplay = (state: State, ownProps: Props) =>
  get(state, `locationAutocomplete.${ownProps.identifier}.inputDisplay`, '');
